import coverIllus from "../assets/illustrations/guide/mental-clarity/cover.svg";
import introductionIllus from "../assets/illustrations/guide/mental-clarity/introduction.svg";
import whatIsIllus from "../assets/illustrations/guide/mental-clarity/what-is.svg";
import whyMattersIllus from "../assets/illustrations/guide/mental-clarity/why-matters.svg";
import signsIllus from "../assets/illustrations/guide/mental-clarity/signs.svg";
import vsMindfulnessIllus from "../assets/illustrations/guide/mental-clarity/vs-mindfulness.svg";
import dailyHabitsIllus from "../assets/illustrations/guide/mental-clarity/daily-habits.svg";
import stressIllus from "../assets/illustrations/guide/mental-clarity/stress.svg";
import atWorkIllus from "../assets/illustrations/guide/mental-clarity/at-work.svg";
import calmMindsetIllus from "../assets/illustrations/guide/mental-clarity/calm-mindset.svg";
import leadersIllus from "../assets/illustrations/guide/mental-clarity/leaders.svg";
import ahavibesIllus from "../assets/illustrations/guide/mental-clarity/ahavibes.svg";

export const GUIDE_COVER = {
  banner: "Take care of your thinking",
  illustration: coverIllus,
  illustrationAlt: "Person in calm reflection surrounded by a floral arc",
};

export const GUIDE_ACCENTS = ["mint", "amber", "electric", "fuchsia"];

export const GUIDE_SECTION_VISUALS = {
  introduction: {
    illustration: introductionIllus,
    illustrationAlt: "Light opening through mental fog",
    banner: "Start here",
  },
  "what-is-mental-clarity": {
    illustration: whatIsIllus,
    illustrationAlt: "Split view of facts versus stories",
    banner: "Foundation",
  },
  "why-mental-clarity-matters": {
    illustration: whyMattersIllus,
    illustrationAlt: "Figure holding clarity symbols like a bouquet",
    banner: "Why it matters",
  },
  "signs-you-lack-mental-clarity": {
    illustration: signsIllus,
    illustrationAlt: "Head surrounded by mental fog and thought loops",
    banner: "Recognize the signs",
  },
  "mental-clarity-vs-mindfulness": {
    illustration: vsMindfulnessIllus,
    illustrationAlt: "Two paths labeled Notice and Decide",
    banner: "Compare concepts",
  },
  "daily-habits": {
    illustration: dailyHabitsIllus,
    illustrationAlt: "Journal checklist with a growing plant sprout",
    banner: "Daily practice",
  },
  "stress-reduces-clarity": {
    illustration: stressIllus,
    illustrationAlt: "Brain under stress with narrowed focus",
    banner: "Under pressure",
  },
  "mental-clarity-at-work": {
    illustration: atWorkIllus,
    illustrationAlt: "Professional communicating clearly at a desk",
    banner: "At work",
  },
  "a-calm-mindset": {
    illustration: calmMindsetIllus,
    illustrationAlt: "Composed figure in a calm circle amid chaos",
    banner: "Stay composed",
  },
  "mental-clarity-for-leaders": {
    illustration: leadersIllus,
    illustrationAlt: "Leader connected to team members",
    banner: "Leadership",
  },
  "ahavibes-perspective": {
    illustration: ahavibesIllus,
    illustrationAlt: "Watering a brain-flower plant to nurture clarity",
    banner: "The Ahavibes view",
  },
};

export function getGuideSectionVisual(sectionId) {
  return GUIDE_SECTION_VISUALS[sectionId] || null;
}

export function getGuideAccent(index) {
  return GUIDE_ACCENTS[index % GUIDE_ACCENTS.length];
}
